import React, { Fragment } from 'react';
import styled from '@emotion/styled';

import PageTitle from '../../common/PageTitle';

import { getCollectionImageUrl } from '../../../helpers';

const getFillTypeString = (fillType) => {
  if (fillType === 'MANUAL') return 'Вручную';
  if (fillType === 'AUTO') return 'Авто';
  return null;
};

const TableWrapper = styled('div')`
  .fixed-table-body {
    overflow-x: auto;
  }
  table.table {
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 0;
    tr {
      cursor: pointer;
      &.not-in-catalog {
        opacity: 0.4;
      }
    }
    td {
      vertical-align: middle;
      color: #343a40;
    }
  }
`;

const DesktopComponent = ({
  handleAddCollection,
  handleCatalogTuning,
  handleEditCollection,
  collections,
}) => {
  return (
    <Fragment>
      <PageTitle title="Коллекции" />

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <div className="row mb-2">
                <div className="col-12">
                  <div className="text-lg-right">
                    <button
                      type="button"
                      className="btn btn-danger waves-effect waves-light mr-2"
                      onClick={handleAddCollection}
                    >
                      <i className="fe-plus"></i> Новая коллекция
                    </button>
                    <button
                      type="button"
                      className="btn btn-light waves-effect waves-light"
                      onClick={handleCatalogTuning}
                    >
                      Отображение на сайте
                    </button>
                  </div>
                </div>
              </div>

              <TableWrapper className="bootstrap-table">
                <div className="fixed-table-container">
                  <div className="fixed-table-body">
                    <table className="table table-centered">
                      <thead className="thead-light">
                        <tr>
                          <th style={{ width: '76px' }}></th>
                          <th>Наименование</th>
                          <th>Тип заполнения</th>
                          <th>Количество</th>
                          <th>Отображение на сайте</th>
                        </tr>
                      </thead>

                      <tbody>
                        {collections.map((c, i) => (
                          <tr
                            key={c.id}
                            onClick={() => handleEditCollection(c.id)}
                            className={`${!c.includedInCatalog ? 'not-in-catalog' : ''}`}
                          >
                            <td style={{ width: '76px' }}>
                              <div
                                className="image-block"
                                style={{ backgroundImage: `url(${getCollectionImageUrl(c, 100)})` }}
                              />
                            </td>
                            <td>{c.title}</td>
                            <td>{getFillTypeString(c.fillType)}</td>
                            <td>{c.products ? c.products.length : null}</td>
                            <td style={{ fontSize: '20px' }}>
                              <i className={c.includedInCatalog ? 'fe-eye' : 'fe-eye-off'} />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {/* <Pagination total={totalItems} onPageSelect={pageIndex => this.handlePageSelect(pageIndex)} /> */}
                  </div>
                </div>
              </TableWrapper>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default DesktopComponent;
